import BenefitsTab from './BenefitsTab';

export default BenefitsTab;
